export const formatNotifyManagersToast = (result = {}, { name } = {}) => {
  const managers = result.managerCount ?? 0
  if (managers === 1 && name) {
    return `Manager notified about ${name}.`
  }
  if (managers === 1) {
    return '1 manager notified.'
  }
  if (managers > 1) {
    return `${managers} managers notified.`
  }
  if ((result.skippedCount ?? 0) > 0) {
    return 'Managers already notified today were skipped.'
  }
  return 'No managers to notify.'
}
